// Override Settings
var bcSfSearchSettings = {
    search: {
        // suggestionMode: 'test', // enable this to prevent closing seach box when testing
        suggestionStyle: 'style2',
        suggestionStyle2MainContainerSelector: 'header:first',
        suggestionStyle2ReverseProductBlock: false,
        suggestionStyle2ProductPerRow: 3,
        showSuggestionLoading: true,
        suggestionBlocks: [
            {
                type: "suggestions",
                number: 5
            },
            {
                type: "collections",
                number: 5
            },
            {
                type: "products",
                number: 4
            },
            // {
            //     type: "pages",
            //     label: "Articles",
            //     number: 5
            // }
        ]
    }
};

class D2XAndFOCDiscountsSearch {
    constructor(product) {
        this.product = product;
        this.customer = window.shop.customer_d2x;

        this.d2x_metafield_discount = this.customer.d2x_metafield_discount
        this.d2x_metafield_limit = this.customer.d2x_metafield_limit
        this.d2x_metafield_expense = this.customer.d2x_metafield_expense
        this.foc_metafield_discount = this.customer.foc_metafield_discount
        this.foc_metafield_limit = this.customer.foc_metafield_limit
        this.foc_metafield_expense = this.customer.foc_metafield_expense
        this.is_customer = this.customer.is_customer

        this.customer_has_d2x_discount = this.defineCustomerD2Xdiscount();
        this.customer_has_foc_discount = this.defineCustomerFOCdiscount();


        this.is_d2x_discount = false;
        this.is_foc_discount = false;
        this.product_has_discount = false;
        this.product_has_d2x_discount = false;
        this.product_has_foc_discount = false;

        this.product_foc_discounts = [];
        this.product_d2x_discounts = [];
        this.foc_metafield_discount_array = [];
        this.foc_metafield_discount_array = [];
    }

    result() {
        if (!this.customer) {
            return this.product;
        }

        if (this.product?.modify) {
            return this.product
        }

        if (!this.customer_has_d2x_discount && !this.customer_has_foc_discount) {
            return this.product;
        }

        this.defineProductDiscounts();

        this.product_has_d2x_discount = !!this.product_d2x_discounts.length
        this.product_has_foc_discount = !!this.product_foc_discounts.length
        this.product_has_discount = this.product_has_d2x_discount && this.product_has_foc_discount

        if (!this.product_has_d2x_discount && !this.product_has_foc_discount) {
            return this.product;
        }

        this.d2x_metafield_discount_array = this.d2x_metafield_discount?.split(',')?.map(el => el.trim())
        this.foc_metafield_discount_array = this.foc_metafield_discount?.split(',')?.map(el => el.trim())

        this.defineLimits();
        this.defineDiscounts();
        this.d2x_percent_discount = this.getD2XDiscount();

        if (this.is_foc_discount) {
            this.modifyProductWithFOCDiscount();
        }

        if (this.is_d2x_discount && !this.is_foc_discount) {
            this.modifyProductWithD2XDiscount();
        }

        this.product.modify = true;
        return this.product;


    }

    modifyProductWithFOCDiscount() {
        const {price,compare_at_price} = this.product;

        const sale_discount = compare_at_price - price

        if (sale_discount > this.foc_different) {
            return null
        }

        let resultPrice = price - this.foc_different

        if (compare_at_price && compare_at_price > 0 && this.foc_different > sale_discount ) {
            resultPrice = compare_at_price - this.foc_different
        } else {
            this.product.compare_at_price = price
        }

        resultPrice > 0 ? this.product.price = resultPrice : this.product.price = 0

    }

    modifyProductWithD2XDiscount() {
        const {price,compare_at_price} = this.product;

        const sale_discount = compare_at_price - price

        if (compare_at_price && compare_at_price > 0) {
            let discount = compare_at_price * this.d2x_percent_discount / 100

            if (discount > this.d2x_different) {
                discount = this.d2x_different
            }

            if (sale_discount > discount) {
                return null;
            }

            this.product.price = compare_at_price - discount


        } else {

            let discount = price * this.d2x_percent_discount / 100

            if (discount > this.d2x_different) {
                discount = this.d2x_different
            }

            this.product.price = price - discount
            this.product.compare_at_price = price
        }

    }

    defineCustomerD2Xdiscount () {
        return !!(this.d2x_metafield_discount && this.d2x_metafield_limit && this.d2x_metafield_expense)
    }

    defineCustomerFOCdiscount() {
        return !!(this.foc_metafield_discount && this.foc_metafield_limit && this.foc_metafield_expense)
    }

    defineProductDiscounts() {

        let metafield = this.product.metafields.find(el => el.namespace === 'd2x_foc' && el.key === 'discount_type')

        if(!metafield) {
            return null
        }

        let tags = metafield?.value?.split(',')?.map(el => el.trim())


        this.product_foc_discounts = tags.filter(tag => {
            return tag.includes('foc::')
        })

        this.product_d2x_discounts = tags.filter(tag => {
            return tag.includes('discount::')
        })

        // const {tags} = this.product;
        //
        // this.product_foc_discounts = tags.filter(tag => {
        //     return tag.includes('foc::')
        //   })
        //
        // this.product_d2x_discounts = tags.filter(tag => {
        //   return tag.includes('discount::')
        // })


    }

    defineLimits() {
        this.foc_different = (this.foc_metafield_limit - this.foc_metafield_expense) * 100.0
        this.d2x_different = (this.d2x_metafield_limit - this.d2x_metafield_expense) * 100.0
    }

    defineDiscounts() {

        const FOC_compare = this.foc_metafield_discount_array?.some(v => v.includes(this.product_foc_discounts)) || false
        const D2X_compare = this.d2x_metafield_discount_array?.some(v => v.includes(this.product_d2x_discounts)) || false

        this.is_d2x_discount = !!(this.product_has_d2x_discount && this.d2x_different > 0 && this.customer_has_d2x_discount && D2X_compare)
        this.is_foc_discount = !!(this.product_has_foc_discount && this.foc_different > 0 && this.customer_has_foc_discount && FOC_compare)
    }

    getD2XDiscount() {
        const D2X_metafield = this.d2x_metafield_discount_array?.find(v => v.includes(this.product_d2x_discounts))

        if (D2X_metafield) {
            let tag = D2X_metafield.split('::')
            return parseInt(tag.pop())
        }

        return null;
    }
}

theme.current.search = theme.current.search || {};

var _BCSfSuggestionCallback = BCSfSuggestionCallback;
BCSfSuggestionCallback = function() {
    for (var index = 0; index < arguments[0].products.length; index++) {
        arguments[0].products[index].price = arguments[0].products[index].price_min * 100;
        // arguments[0].products[index].featured_image = {}
        arguments[0].products[index].featured_image = arguments[0].products[index].images_info[0];
        if(arguments[0].products[index].images_info[1]) arguments[0].products[index].second_image = arguments[0].products[index].images_info[1].src;

        arguments[0].products[index].url = '/products/'+ arguments[0].products[index].handle;
        arguments[0].products[index].price_varies = arguments[0].products[index].price_max != arguments[0].products[index].price_min;
        arguments[0].products[index].type = arguments[0].products[index].product_type;
        arguments[0].products[index].selected_or_first_available_variant = _.find(arguments[0].products[index].variants, function(o){return o.available});
        arguments[0].products[index].compare_at_price = arguments[0].products[index].compare_at_price_max * 100;

    }
    console.log(arguments[0].products)
    // arguments[0].products = arguments[0].products.slice(0, 4);
    _BCSfSuggestionCallback.apply( this, arguments );
};


// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  theme.current.search.popupOpen = true;
//   theme.utils.lockPageScroll(suggestionElement[0]);
};

BCSfFilter.prototype.buildSuggestion = function(searchTerm, suggestionData, ul, searchBoxId) {
    console.log("suggestionData:", suggestionData)

    let products = suggestionData.find(el => el.key === 'products');

    if (products?.values?.length) {
        products.values = products.values.map(product => {
            const getDiscount = new D2XAndFOCDiscountsSearch(product);
            return getDiscount.result();

        })
    }


    searchTerm = this.escape(searchTerm);
    $('html').addClass('lock-scroll');
    var noResults = getValueInObjectArray('all_empty', suggestionData);

    var i = suggestionData.length;
    while(i--) {
      theme.current.search[suggestionData[i].key] = JSON.parse(JSON.stringify(suggestionData[i].values));
    }

    jQ(ul).append(theme.SearchPopup.getPopup());

    // Wrapper
    this.buildSuggestionWrapper(ul, searchBoxId);
};

BCSfFilter.prototype.isMobile = function() {
  return false;
}

// Wrap Suggestion
BCSfFilter.prototype.buildSuggestionWrapper = function(ul, searchBoxId) {
    var self = this;
    var suggestionPosition = getSuggestionPosition(searchBoxId);
    if (self.isSuggestionStyle2()) {
        var suggestionStyle2MainContainerSelector = self.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';
        jQ(suggestionStyle2MainContainerSelector).css('position', 'relative');
    }
    var wrapperClass = this.class.searchSuggestionWrapper;
    var popoverClass = 'bc-sf-search-suggestion-popover';
    if (!jQ(ul).parent().hasClass(wrapperClass)) {
        var mobileClass = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? this.class.searchSuggestionMobile : '';
        jQ(ul).wrap('<div class="' + wrapperClass + ' ' + mobileClass + '"></div>');
        // Add Arrow
        jQ(ul).parent().prepend('<div class="' + popoverClass + '" data-direction="' + suggestionPosition + '"></div>');
    }
    if (self.isSuggestionStyle2() && jQ('.' + self.class.searchSuggestionWrapper).length > 0) {
        var wrapperSearch = jQ('.' + self.class.searchSuggestionWrapper);
        wrapperSearch.addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle'))
            .addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle') + '-width-fullwidth')
            .addClass(self.class.searchSuggestion + '-products-per-row-' + self.getSettingValue('search.suggestionStyle2ProductPerRow'))
            .addClass(self.class.searchSuggestion + '-reverse-product-block-' + self.getSettingValue('search.suggestionStyle2ReverseProductBlock'));
    }
    jQ(ul).siblings().show();
    // Set open position of parent of Suggestion box
    var topPosition = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? 'top' : 'top+12';
    if (suggestionPosition == 'left') {
        jQ(ul).parent().position({
            my: 'left ' + topPosition,
            at: 'left bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'left+20 top-8' + topPosition,
                at: 'left bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    } else {
        jQ(ul).parent().position({
            my: 'right ' + topPosition,
            at: 'right bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'right-20 top-8',
                at: 'right bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    }
    buildPopOverClassPosition();
    // Set width for wrapper
    if (!self.isSuggestionStyle2()) {
        var width = this.getSuggestionWidth(searchBoxId);
        jQ(ul).parent().outerWidth(width);
    } else {
        jQ(window).resize(function() {
            buildPopOverClassPosition();
        });
    }
};

BCSfFilter.prototype.closeSuggestionEvent = function(searchBoxId) {
    // Test Mode - Turn on when need check elements of Auto Complete
    // Prevent closing Auto complete when opening Inspect Element
    if (this.getSettingValue('search.suggestionMode') == 'test' || this.checkIsFullWidthSuggestionMobile(searchBoxId)) {
        // if (!jQ('ul.ui-autocomplete').is(":visible")) {
        jQ('.' + this.class.searchSuggestion).show();
        // }
    } else {
        jQ('.' + this.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').siblings().hide();
    }
    // Always hide loading and show content
    this.hideSuggestionLoading();
    //

    theme.current.search.popupOpen = false;
    theme.utils.unlockPageScroll();

    console.info('close');
};

BCSfFilter.prototype.showSuggestionLoading = function() {
  theme.current.search.loading = true;
}

BCSfFilter.prototype.hideSuggestionLoading = function() {
  theme.current.search.loading = false;
}

BCSfFilter.prototype.buildSearchBox = function(id, bcsf) {
    if(bcsf) {
        var _this = bcsf
    } else {
        var _this = this
    }

    // Customize Search box before building Auto suggestion
    _this.beforeBuildSearchBox(id);
    // var _this = this;
    if (jQ(id).length > 0) {
        var appendToSelector;
        if (_this.isSuggestionStyle2() && jQ(window).width() > 768) {

            appendToSelector = _this.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';

        } else {
            appendToSelector = 'body';
        }
        var queryValue = this.currentTerm = getParam(this.searchTermKey || "");

        jQ(id).val(queryValue);
        var $autocomplete = jQ(id)
            .autocomplete({
                appendTo: appendToSelector,
                minLength: _this.getSettingValue('search.suggestionMinLength'),
                delay: 200,
                source: function(request, response) {
                    window.suggestionCallback = response;
                    _this.currentTerm = request.term;
                    var term = (request.term).toLowerCase().trim().replace(/\s+/g, ' ');
                    if (term != '') {
                        // Show Loading
                        var suggestion = getSuggestionInstance(id);
                        _this.showSuggestionLoading(suggestion, id);
                        // Get data from cache
                        if (term in _this.suggestionCache) {
                            suggestionCallback(_this.suggestionCache[term]);
                            return;
                        }
                        _this.getSuggestionData(term, 0, 'suggest');
                    }
                },
                classes: {
                    'ui-autocomplete': _this.class.searchSuggestion
                },
                // position: {my: "left+0 top+12"},
                response: function(ev, ui) {
                    // Prepare data
                    var result = ui.content;
                    var searchTerm = getValueInObjectArray('query', result);
                    var eventType = getValueInObjectArray('event_type', result);
                    var suggestQuery = getValueInObjectArray('suggest_query', result);
                    var localCache = getValueInObjectArray('local_cache', result);
                    // Cache
                    if (Object.keys(_this.suggestionCache).length == 25) _this.suggestionCache = {};
                    if (!(searchTerm in _this.suggestionCache) && eventType != 'suggest_dym') {
                        _this.suggestionCache[searchTerm] = result;
                    }
                    // Send another request to get the product list of suggest_query
                    if (suggestQuery != '' && eventType == 'suggest' && !localCache) {
                        _this.getSuggestionData(suggestQuery, 0, 'suggest_dym', searchTerm);
                    }
                    // Hide loading after receiving the API response
                    _this.hideSuggestionLoading(id);
                },
                focus: function(ev, ui) {
                    return false;
                },
                open: function(ev, ui) {
                    _this.openSuggestionEvent(id, ev);
                },
                close: function(ev, ui) {
                    _this.closeSuggestionEvent(id, ev);
                },
                select: function(ev, ui) {
                    return false;
                }
            })
            // Display autocomplete on focus event
            .on('click', function(ev) {
                _this.clickSearchBoxEvent(id, ev);
            })
            .on('focus', function(ev) {
                _this.focusSearchBoxEvent(id, ev);
            })
            // Catch the type event in search box
            .on('keyup', function(ev) {
                _this.typeSearchBoxEvent(id, ev);
            })
            // Add some additional attributes
            .addClass(_this.class.searchBox)
            .attr('data-search-box', id)
            .data( "uiAutocomplete" );

        var originalCloseFunc = $autocomplete.close;
        $autocomplete.close = function() {
              if(!$autocomplete.term || !isMobile.any) {
                var dropdown = jQ('.bc-sf-search-suggestion-wrapper').get(0);
                if (dropdown && event && !dropdown.contains(event.target) && dropdown != event.target) {
                    $('html').removeClass('lock-scroll');
                    originalCloseFunc.apply( this, arguments );
                }
              } else {
                $('html').addClass('lock-scroll');
              }
        };
        // Build Auto Suggestion
        jQ(id).autocomplete('instance')._renderMenu = function(ul, data) {
            ul.attr('data-search-box', id);
            return _this.buildSuggestion(this.term, data, ul, id);
        };
        // Resize Suggestion box
        jQ(id).autocomplete('instance')._resizeMenu = function() {
            var suggestionElement = this.menu.element;
            var searchElement = this.element;
            _this.buildStyleSuggestion(suggestionElement, searchElement, id);
        };
        // Close Suggestion box when click outside autocomplete region
        // _this.clickOutsideSuggestionEvent(id);
    }
    // Set open position of Suggestion box
    // this.setSuggestionPosition(id);
};
